import type { Recurrence, RnbCalculatorPayload } from 'typings'
import { toCronExpression } from 'ui'
import type { AdvancedScheduling } from '../../../typings'

type APISchedulingPayload = Pick<
  RnbCalculatorPayload,
  'beginDateUtc' | 'endDateUtc' | 'recurrencyCrons' | 'newOffset'
>

const HOUR_IN_MIN = 60

function mapRecurrenceCrons(recurrence?: Recurrence): string[] | undefined {
  const hasAnyRecurrenceSettings =
    recurrence?.weekdays.length || recurrence?.timeIntervals.length

  if (!recurrence || !hasAnyRecurrenceSettings) {
    return undefined
  }

  return [toCronExpression(recurrence)]
}

export function toAPIScheduling({
  start,
  end,
  recurrence,
}: AdvancedScheduling): APISchedulingPayload {
  return {
    beginDateUtc: start!.toISOString(),
    endDateUtc: end!.toISOString(),
    recurrencyCrons: mapRecurrenceCrons(recurrence),
    newOffset: (-1 * new Date().getTimezoneOffset()) / HOUR_IN_MIN || 0,
  }
}
